// extracted by mini-css-extract-plugin
module.exports = {"header":"Collapse_header__e6aXL","isOpened":"Collapse_isOpened__25Fez","arrow":"Collapse_arrow__hZT_r"};